import CustomSelect from "@common/CustomSelect";
import selectArrowIcon from "@assets/icons/select_arrow.svg";
import { Empty, Spin, Tooltip } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { IconButton, PrimaryButton, SecondaryButton } from "@common/Buttons";
import downloadActiveIcon from "@assets/icons/download_active.svg";
import { useDownloadFileMutation } from "@store/file";
import { downloadBlobAsFile } from "@store/utilities";
import downloadIcon from "@assets/icons/download.svg";

export default function ProductionSelectionArea({
  activeProduct,
  activeTab,
  updateQueryWithTabChange,
  productList,
  subsectionList,
  isLoading,
  hiddenSidebar,
}) {
  const [downloadFile, { isLoading: downloadFileLoading }] =
    useDownloadFileMutation();

  const handleDownload = async () => {
    const response = await downloadFile({
      url: "download-product-insights",
    });
    if (response) {
      downloadBlobAsFile(response.data, "product-insights.pdf");
    }
  };

  //rendering products for desktop
  const renderedProducts = productList.map((pro, index) => {
    const isActiveProduct = pro.id === activeProduct;
    return (
      <div key={pro.id} className="flex flex-col gap-2.5">
        <div className="flex items-center justify-between">
          <label
            className={`text-[#444444] font-semibold text-base transition-all duration-300 ${
              isActiveProduct
                ? "cursor-not-allowed"
                : "cursor-pointer hover:brightness-150"
            }`}
            onClick={() =>
              isActiveProduct ? null : updateQueryWithTabChange(pro.id, null)
            }
          >
            {pro.name} {pro["isR&D"]? "(R&D)": null}
            {isLoading && (
              <Spin
                indicator={
                  <Loading3QuartersOutlined
                    spin
                    className="!text-primary-tint !text-[10px]"
                  />
                }
                size="small"
                className="!ml-2"
              />
            )}
          </label>
          {index === 0 && (
            <Tooltip title="Download PDF">
              <div>
                <IconButton
                  icon={downloadActiveIcon}
                  activeIcon={downloadIcon}
                  className={`!mr-2 hidden !border-primary-tint transition-all duration-300 rounded-lg ${
                    downloadFileLoading
                      ? "cursor-not-allowed p-0 border-none"
                      : "cursor-pointer p-1.5 border hover:!bg-primary-tint"
                  }`}
                  onClick={handleDownload}
                  loading={downloadFileLoading}
                />
              </div>
            </Tooltip>
          )}
        </div>
        {activeProduct === pro.id ? (
          <div className="flex flex-col ml-5">
            {subsectionList.map((tab) => {
              const isActiveTab = tab.id === activeTab;
              return (
                <span
                  key={tab.label}
                  onClick={() => updateQueryWithTabChange(pro.id, tab.id)}
                  className={`text-sm  py-0.5 font-semibold transition-all duration-300  ${
                    isActiveTab
                      ? "border-l-2 border-l-primary-tint text-primary-tint pl-2.5 cursor-not-allowed"
                      : "cursor-pointer hover:brightness-150 text-text-tint"
                  }`}
                >
                  {tab.displayName}
                </span>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  });

  return (
    <>
      <div
        className={
          hiddenSidebar
            ? "hidden"
            : "w-[30%] lg:w-[25%] hidden md:flex flex-col gap-2.5 overflow-auto custom-scrollbar border-r border-gray-200"
        }
      >
        {renderedProducts.length ? (
          renderedProducts
        ) : (
          <div className="flex items-center justify-center h-full">
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        )}
      </div>
      {/* //rendering products for mobile */}
      <div className="flex items-center w-full gap-4 px-1 py-4 overflow-x-auto overflow-y-hidden hide-scroll md:hidden">
        <CustomSelect
          onChange={(pro) =>
            updateQueryWithTabChange(
              pro,
              subsectionList.find((pro) => pro.id === activeProduct)?.id
            )
          }
          value={activeProduct}
          options={productList.map((pro) => ({
            label: pro.name,
            value: pro.id,
          }))}
          variant="outlined"
          icon={selectArrowIcon}
          placeholder="Select product"
          loading={isLoading}
        />
        <CustomSelect
          onChange={(tab) => updateQueryWithTabChange(activeProduct, tab)}
          value={activeTab}
          options={subsectionList.map((tab) => ({
            label: tab.name,
            value: tab.id,
          }))}
          variant="outlined"
          icon={selectArrowIcon}
          placeholder="Select type"
          loading={isLoading}
        />
      </div>
    </>
  );
}
